export default __webpack_public_path__ + "static/iconography-styles-0eb938febd9d6a1e86265f738b67dc92.png";